<script setup>
	import { computed, onMounted, onUnmounted, onBeforeMount, ref } from 'vue';
	import Header from '@/components/Header.vue';
	import { useMapStoreData } from '@/stores/index';
	import { useRoute } from 'vue-router';
	const route = useRoute();
	const mapStore = useMapStoreData();
	const id = computed(() => route.params.id);
	const module = computed(() => mapStore.routes[id.value]);

	const getLocalizedUrls = (routeModule) => {
		const localizedUrls = routeModule?.urls ?? routeModule?.locale;
		if (!localizedUrls || typeof localizedUrls !== 'object') return null;
		return localizedUrls;
	};

	const hasLocalizedUrls = computed(() => {
		const localizedUrls = getLocalizedUrls(module.value);
		if (!localizedUrls) return false;
		return Object.values(localizedUrls).filter((value) => typeof value === 'string' && value.length > 0).length > 1;
	});

	const resolveIframeUrl = (routeModule, language) => {
		if (!routeModule) return '';

		const localizedUrls = getLocalizedUrls(routeModule);
		if (localizedUrls) {
			if (language && localizedUrls[language]) return localizedUrls[language];
			if (routeModule.url) return routeModule.url;
			const firstUrl = Object.values(localizedUrls).find((value) => typeof value === 'string' && value.length > 0);
			if (firstUrl) return firstUrl;
		}

		return routeModule.url ?? '';
	};

	const url = computed(() => {
		const baseUrl = resolveIframeUrl(module.value, mapStore.currentLanguage);
		return baseUrl + '?timestamp=' + new Date().getTime();
	});
	const showIframe = ref(false);
	const setupDataHeader = computed(() => ({
		centerIcon: true,
		orderFilter: false,
		search: false,
		backArrow: false,
		backArrowMap: true,
		shortHeader: false,
		hideLanguage: !hasLocalizedUrls.value,
	}));
	onMounted(() => {
		setTimeout(() => {
			showIframe.value = true;
		}, 50);
		useMapStoreData().hideMap = true;
	});
	onBeforeMount(() => {
		showIframe.value = false;
		useMapStoreData().hideMap = true;
	});
	onUnmounted(() => {
		useMapStoreData().hideMap = true;
		console.log('IFrame component is being unmounted');
	});
</script>

<template>
	<Transition name="iframe-content">
		<div>
			<iframe
				sandbox="allow-top-navigation allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-presentation allow-same-origin allow-scripts"
				:src="url"
			></iframe>
			<Header :setupHeader="setupDataHeader"></Header>
		</div>
	</Transition>
</template>

<style scoped>
	@import '../assets/style/mixins.scss';

	.iframe-content-enter-active,
	.iframe-content-leave-active {
		transition:
			opacity 0.3s ease,
			transform 0.3s ease;
	}
	.iframe-content-enter-from,
	.iframe-content-leave-to {
		opacity: 0;
		transform: translateY(20px);
	}
	.container-iframe {
		z-index: 1;
	}
	iframe {
		margin-top: 6.25vw;
		position: absolute;
		z-index: 0;
		width: 100vw;
		height: calc(100vh - 6.25vw);
		border: none;
	}

	@media only screen and (orientation: portrait) {
		iframe {
			margin-top: 0;
			position: absolute;
			z-index: 0;
			width: 100vw;
			height: calc(100vh - 6vh);
			border: none;
		}
	}
</style>
